import { createUseChoiceAnswer } from 'app/modules/subject';

export const useChoiceOneAnswer = createUseChoiceAnswer(
  'single',
  answers => answers.payload[0] as string,
  (checked, value) => !(!checked || value === ''),
  /**
   * `value === ''` preserved for `<select>`
   */
  (value, checked) => (checked ? [value] : [])
);
